export const SEVERITY = [
  {
    title: 'High',
    value: 'HIGH',
  },
  {
    title: 'Medium',
    value: 'MEDIUM',
  },
  {
    title: 'Low',
    value: 'LOW',
  },
];

export const VIOLATION_TYPE = [
  {
    title: 'Kognitif',
    value: 'KOGNITIF',
  },
  {
    title: 'Psikomotor',
    value: 'PSIKOMOTOR',
  },
  {
    title: 'Afektif',
    value: 'AFEKTIF',
  },
];
